module.exports = __webpack_public_path__ + "static/media/01A.c6adcbb4.png";